import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import TruckIcon from 'mdi-react/TruckIcon';

import BookStatus from 'modules/shared/BookingTable/components/BookStatus';
import BookingTable from 'modules/shared/BookingTable';
import TopBorderBtn from 'modules/shared/TopBorderBtn';
import Loader from 'modules/kiosk/components/Loader';
import BookingHelper from 'modules/shared/BookingTable/utils';
import { useModal } from 'modules/shared/hooks';
import ErrorMsg from 'modules/shared/ErrorMsg';
import { logoutSelector } from 'modules/common/LogoutBtn/selectors';
import { Reservations } from 'entities/Reservations';
import moment from 'moment';
import BlockIcon from 'mdi-react/BlockIcon';
import { reservationsSelector } from './services/selectors';
import {
  editBookRequest,
  getAllBooksError,
  getAllBooksRequest,
  getCellSettingsRequest,
  getLockedCellRequest,
  postBookRequest,
} from './services/actions';
import managerBookingSchema from './schema';
import { RootState } from '../../../../rootReducer';

const Booking: React.FC = () => {
  const dispatch = useDispatch();
  const { isShow, openModal, closeModal } = useModal();
  const [startDay, setStartDay] = useState<Date>();
  const [update, setUpdate] = useState<boolean>();
  const [times, setTimes] = useState<string[]>([]);
  const { loading, error, books, lockedCell } = useSelector(reservationsSelector);
  const cellSetting = useSelector((state: RootState) => state.managerModuleReducer.reservationsReducer.cellSetting);

  const { branchTitle } = useSelector(logoutSelector);

  const branchId = JSON.parse(localStorage.getItem('branchId') || 'null')?.id;

  useEffect(() => {
    dispatch(getCellSettingsRequest());
  }, [branchTitle]);

  setTimeout(() => setUpdate(!update), 40000);

  const handlePrevWeek = () => {
    if (startDay) {
      const d = startDay.setDate(startDay.getDate() - 7);

      setStartDay(new Date(d));
      return true;
    }
  };

  const handleNextWeek = () => {
    if (startDay) {
      const d = startDay.setDate(startDay.getDate() + 7);
      setStartDay(new Date(d));
    }
  };

  const getDatas = (fromDate: Date) => {
    if (branchId) {
      const a = moment(fromDate).unix();
      const b = a + 6 * 86400;
      const c = new Date(moment.unix(b).format());

      const params = {
        branchId: `${branchId}`,
        from: fromDate,
        to: c,
      };
      dispatch(getLockedCellRequest(params));
      dispatch(getAllBooksRequest(params));
    }
  };

  const handleOnBook = (value: Reservations) => {
    if (!value.id.length) return dispatch(postBookRequest(value));

    dispatch(editBookRequest(value));
  };

  useEffect(() => {
    if (!startDay) setStartDay(new Date());

    if (startDay) getDatas(startDay);
  }, [startDay, branchId, update]);

  useEffect(() => {
    if (Object.keys(cellSetting).length !== 0) {
      const time = BookingHelper.generateTimes(cellSetting);
      setTimes(time);
    }
  }, [books, cellSetting]);

  useEffect(() => {
    if (error) {
      return openModal();
    }
    closeModal();
  }, [error]);

  return (
    <Container fluid className="mt-15">
      <Row className="w-100">
        <Col className="d-flex align-items-center col-10 pr-0">
          <span className="col-2">Умовні позначення:</span>
          <div className="d-flex flex-row align-items-center col-2">
            <TruckIcon className="mr-1" size={18} />
            <span>Машина в Е-черзі</span>
          </div>
          <div className="d-flex flex-row align-items-center col-2">
            <BlockIcon className="mr-1" size={18} />
            <span>Слот заповнено</span>
          </div>
        </Col>
      </Row>
      <Row className="w-100">
        <Col className="d-flex align-items-center col-10 pr-0">
          <span className="col-2">Статуси бронювання:</span>
          <div className="d-flex flex-row align-items-center col-2 pr-0">
            <BookStatus status={1} />
            <span>Не підтверджена</span>
          </div>
          <div className="d-flex flex-row align-items-center col-2">
            <BookStatus status={2} />
            <span>Підтверджена</span>
          </div>
          <div className="d-flex flex-row align-items-center col-2">
            <BookStatus status={4} />
            <span>Відхилена</span>
          </div>
          <div className="d-flex flex-row align-items-center col-2 p-0">
            <BookStatus status={5} />
            <span>Іншого менеджера</span>
          </div>
          <div className="d-flex flex-row align-items-center col-2 p-0">
            <BookStatus status={6} />
            <span>Завершено</span>
          </div>
        </Col>
        <div className="d-flex align-items-center justify-content-end col-2 p-0">
          <TopBorderBtn icon="calendarRefresh" className="border-0" clickHandler={() => setStartDay(new Date())} />
          <TopBorderBtn icon="left" clickHandler={handlePrevWeek} />
          <TopBorderBtn icon="right" clickHandler={handleNextWeek} className="ml-0 mr-4" />
        </div>
      </Row>
      {loading ? <Loader /> : null}
      {books && startDay && lockedCell && cellSetting ? (
        <BookingTable
          schema={managerBookingSchema}
          viewStartDate={startDay}
          duration={cellSetting?.slotDurationInMinutes || 30}
          times={times}
          onBook={handleOnBook}
          mode="manager"
          cellLocked={lockedCell}
          maxReservationCount={cellSetting?.maxReservationCount}
        />
      ) : null}
      <ErrorMsg
        isShow={isShow}
        // @ts-ignore
        error={error?.data?.Errors[0]?.Message || 'Помилка при отриманні данних'}
        closeHandler={() => dispatch(getAllBooksError(null))}
      />
    </Container>
  );
};

export default Booking;
